import React from "react";

import { observer } from "mobx-react";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

import {
	CashOutHistoryTableHeader,
	CashOutHistoryValueRow,
} from "./cashout-history-components";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

export const BetDetailsCashOutHistory = observer(
	function BetDetailsCashOutHistory(props: {
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
		isActive: boolean;
	}) {
		const { store, isActive } = props;

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		if (!isActive || !cashoutStore.cashoutHistory) {
			return null;
		}

		return (
			<table className="table--bet u-bg--transparent">
				<CashOutHistoryTableHeader />
				<tbody className="table--primary__body">
					{cashoutStore.cashoutHistory?.betSlipCashoutHistoryValues?.map(
						(row, index) => {
							return (
								<CashOutHistoryValueRow
									key={row.timestamp}
									count={index + 1}
									rowData={row}
								/>
							);
						}
					)}
				</tbody>
			</table>
		);
	}
);
